import axios from 'axios'
const url = process.env.VUE_APP_URL_API
// const url = 'http://localhost/api-cod/cod/manifest_courier/'
const api = axios.create({ 
    baseURL : url
})

export default api